import { render } from "./personage.vue?vue&type=template&id=26cf4f86&scoped=true"
import script from "./personage.vue?vue&type=script&lang=js"
export * from "./personage.vue?vue&type=script&lang=js"

import "./personage.vue?vue&type=style&index=0&id=26cf4f86&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cf4f86"]])

export default __exports__